import React, { Component } from "react";
import { queryserviceobject } from "../../services/crudservice";
import { Label, Grid, Table, Input, Divider } from "semantic-ui-react";
import moment from "moment";
class JobInfo extends Component {
  constructor() {
    super();
    this.state = {
      startdate: null,
      enddate: null
    };
  }
  componentDidMount() {
    queryserviceobject("reports", { report: "payroll" });
  }
  gentable(data) {
    if (data && data.length) {
      return data.map(empdata => {
        return (
          <Table.Row error={empdata.totalhours < 40}>
            <Table.Cell>{empdata.empnumber}</Table.Cell>
            <Table.Cell>{empdata.empname}</Table.Cell>
            <Table.Cell>{empdata.regularhours}</Table.Cell>
            <Table.Cell>{empdata.ptohours}</Table.Cell>
            <Table.Cell>{empdata.unpaidhours}</Table.Cell>
            <Table.Cell>{empdata.totalhours}</Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  gentableheader(data) {
    if (data) {
      return (
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Employee Number</Table.HeaderCell>
              <Table.HeaderCell>Employee Name</Table.HeaderCell>
              <Table.HeaderCell>Regular Hours</Table.HeaderCell>
              <Table.HeaderCell>PTO Hours</Table.HeaderCell>
              <Table.HeaderCell>Unpaid Hours</Table.HeaderCell>
              <Table.HeaderCell>Total Hours</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.gentable(data)}</Table.Body>
        </Table>
      );
    }
  }
  render() {
    var data;
    if (this.state.startdate && this.state.enddate) {
      data = queryserviceobject("reports", {
        report: "payroll",
        startdate: this.state.startdate,
        enddate: this.state.enddate
      });
    }
    return (
      <div className="JobInfo">
        <Grid>
          <Grid.Column width={5}>
            <Label>Select Start Date</Label>
            <Input
              placeholder="Start Date"
              fluid
              type="date"
              value={this.state.startdate}
              onChange={e =>
                this.setState({
                  startdate: moment(e.target.value).format("YYYY-MM-DD")
                })
              }
            />
          </Grid.Column>
          <Grid.Column width={2} />
          <Grid.Column width={6}>
            <Label>Select End Date</Label>
            <Input
              placeholder="End Date"
              fluid
              type="date"
              value={this.state.enddate}
              onChange={e =>
                this.setState({
                  enddate: moment(e.target.value).format("YYYY-MM-DD")
                })
              }
            />
          </Grid.Column>
          <Grid.Column width={1} />
        </Grid>
        <Divider />
        this.gentableheader(data)
      </div>
    );
  }
}

export default JobInfo;



// WEBPACK FOOTER //
// ./src/components/jobtrack/jobinfo.js